import { render } from "./IPAllowed.vue?vue&type=template&id=950bb740&scoped=true"
import script from "./IPAllowed.vue?vue&type=script&lang=js"
export * from "./IPAllowed.vue?vue&type=script&lang=js"

import "./IPAllowed.vue?vue&type=style&index=0&id=950bb740&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-950bb740"]])

export default __exports__